<template lang="pug">
pr-wrapper.keyboard.animated(fs, :zi="index", v-visible="activated")
  pr-wrapper.animated.border.row.no-gutters(
    v-show="isNumeric",
    bg="darken",
    zi="1",
    v-nv:scope="'keyboard-numeric'",
    data-loop="horizontal",
    nv-sleep-protect,
    ref="keyboard-numeric",
    nv-exit-protect,
    @nv-exit.native="close",
    @nv-back.native="close"
  )
    .col.col-auto.p-0.border-right(v-show="!onlyNumbers")
      .d-block(v-nv, @nv-enter="typed", data-value="ABC")
        .common.background ABC
    .col.p-0
      .numpad-row
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="1") 1
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="2") 2
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="3") 3
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="4") 4
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="5") 5
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="6") 6
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="7") 7
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="8") 8
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="9") 9
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="0") 0
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value=".", v-show="!onlyNumbers") .
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value=":", v-show="!onlyNumbers") :
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="/", v-show="!onlyNumbers") /
    .col.col-auto.p-0.border-right
      .d-block.background(v-nv, @nv-enter="typed", data-value="delete")
        .common
          icon(:icon="'backspace'")
    .col.col-auto.p-0
      .d-block.background(v-nv, @nv-enter="typed", data-value="enter")
        .common Enter
  pr-wrapper.animated.border.row.no-gutters(
    v-show="!isNumeric",
    bg="darken",
    zi="1",
    v-nv:scope="'keyboard-alphabetical'",
    data-loop="horizontal",
    nv-sleep-protect,
    ref="keyboard-alphabetical",
    nv-exit-protect,
    @nv-exit.native="close",
    @nv-back.native="close"
  )
    .col.col-auto.p-0.border-right
      .d-block
        .common.background.border-bottom(v-nv, @nv-enter="typed", data-value="123") 123
        .common.background(v-nv, @nv-enter="typed", data-value="toggleABC") {{ isLowerCase ? "ABC" : "abc" }}
    .col.p-0
      .numpad-row
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'A' : 'a'") {{ !isLowerCase ? "A" : "a" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'B' : 'b'") {{ !isLowerCase ? "B" : "b" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'C' : 'c'") {{ !isLowerCase ? "C" : "c" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'D' : 'd'") {{ !isLowerCase ? "D" : "d" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'E' : 'e'") {{ !isLowerCase ? "E" : "e" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'F' : 'f'") {{ !isLowerCase ? "F" : "f" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'G' : 'g'") {{ !isLowerCase ? "G" : "g" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'H' : 'h'") {{ !isLowerCase ? "H" : "h" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'I' : 'i'") {{ !isLowerCase ? "I" : "i" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'J' : 'j'") {{ !isLowerCase ? "J" : "j" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'K' : 'k'") {{ !isLowerCase ? "K" : "k" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'L' : 'l'") {{ !isLowerCase ? "L" : "l" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'M' : 'm'") {{ !isLowerCase ? "M" : "m" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'N' : 'n'") {{ !isLowerCase ? "N" : "n" }}
        .numpad.background.border-right.border-bottom(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'O' : 'o'") {{ !isLowerCase ? "O" : "o" }}
      .numpad-row
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'P' : 'p'") {{ !isLowerCase ? "P" : "p" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'Q' : 'q'") {{ !isLowerCase ? "Q" : "q" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'R' : 'r'") {{ !isLowerCase ? "R" : "r" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'S' : 's'") {{ !isLowerCase ? "S" : "s" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'T' : 't'") {{ !isLowerCase ? "T" : "t" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'U' : 'u'") {{ !isLowerCase ? "U" : "u" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'V' : 'v'") {{ !isLowerCase ? "V" : "v" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'W' : 'w'") {{ !isLowerCase ? "W" : "w" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'X' : 'x'") {{ !isLowerCase ? "X" : "x" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'Y' : 'y'") {{ !isLowerCase ? "Y" : "y" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", :data-value="!isLowerCase ? 'Z' : 'z'") {{ !isLowerCase ? "Z" : "z" }}
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value=" ") space
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="-") -
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value="@") @
        .numpad.background.border-right(v-nv, @nv-enter="typed", data-value=".") .
    .col.col-auto.p-0.border-right.d-flex
      .d-flex.align-items-center.background(v-nv, @nv-enter="typed", data-value="delete")
        .common
          icon(:icon="'backspace'")
    .col.col-auto.p-0.d-flex
      .d-flex.align-items-center.background(v-nv, @nv-enter="typed", data-value="enter")
        .common Enter
</template>

<script>
export default {
  name: "keyboard",
  data() {
    return {
      isLowerCase: false,
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0"
    }
  },
  computed: {
    isNumeric() {
      return ["number", "numeric"].includes(this.payload.type) ? true : false
    },
    onlyNumbers() {
      return ["numeric"].includes(this.payload.type) ? true : false
    }
  },
  watch: {
    isNumeric(nval) {
      if (!this.activated) return false
      this.$nextTick().then(() => _$.nav.changeScope(nval ? "keyboard-numeric" : "keyboard-alphabetical"))
    },
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "104" : "0"
    }
  },
  mounted() {
    _$.nav.sync("keyboard-numeric")
    _$.nav.sync("keyboard-alphabetical")

    _$.vue.$on("keyboard", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    typed() {
      const el = _$.nav._currentScope.currentElement

      switch (el.dataset.value) {
        case "toggleABC":
          this.isLowerCase = !this.isLowerCase
          break
        case "ABC":
          this.payload.type = false
          break
        case "123":
          this.payload.type = "number"
          break
        case "delete":
          _$.nav.trigger("left", this.payload.target, "left")
          _$.nav.trigger("delete", this.payload.target, "delete")
          break
        case "enter":
          this.close(true, true)
          break
        default:
          _$.nav.trigger("numpad", this.payload.target, el.dataset.value)
          break
      }
    },
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close()
      if (this.activated) this.payload.reject()

      this.payload = payload

      //await this.setDisplayMetrics()
      await this.$nextTick()

      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }
      _$.nav.changeScope(this.isNumeric ? "keyboard-numeric" : "keyboard-alphabetical")
      await _$.sleep(200)
      this.activated = true
    },
    async setDisplayMetrics() {
      const rect = this.payload.target.getBoundingClientRect()

      let styles = {
        left: Math.floor(rect.left + rect.width / 2) + "px",
        bottom: null,
        top: null,

        maxWidth: Math.floor(rect.width - this.payload.offset * 2) + "px",
        overflow: "hidden",
        borderRadius: "5px"
      }

      if (rect.top > window.innerHeight - rect.bottom) styles.bottom = window.innerHeight - rect.top + 5 + "px"
      else styles.top = rect.bottom + 5 + "px"

      Object.assign(this.$refs.keyboard.$el.style, styles)
      return true
    },
    close(reason, resolve) {
      if (!this.activated) return false

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (resolve) this.payload.resolve(resolve)
      else this.payload.reject()

      this.payload = {}

      if (resolve) return resolve
      else return false
    }
  }
}
</script>

<style lang="scss" scoped>
#keyboard-numeric,
#keyboard-alphabetical {
  position: fixed;
  z-index: 999;
  overflow: hidden;
  left: 0;
  right: 0;
  bottom: 0;
  box-shadow: 10px 0px 15px 2px rgba(0, 0, 0, 0.5);

  .common {
    padding: 0.75rem 1rem;
    text-align: center;
  }

  .numpad-row {
    display: flex;
    .numpad {
      flex: 1 1 60px;
      padding: 0.75rem 0;
      text-align: center;
    }
  }
}
</style>
